interface IUserGroup {
  id: string;
  name: string;
  path?: string;
}

export interface IUser {
  id: string,
  username: string,
  rolename: string,
  firstName: string,
  lastName: string,
  email: string,
  emailVerified: boolean,
  password: string,
  confirmPassword: string,
  createdTimestamp: number,
  enabled: boolean,
  groupId: string,
  totp: false,
  disableableCredentialTypes: [],
  requiredActions: [],
  notBefore: number,
  access: IUserAccess,
  attributes: { userType?: number[]; payers?: string[]; providers?: string[]; patient?: string[];[key: string]: string[] | number[] | undefined };
  userType: number;
  providers?: string | string[];
  payers?: string | string[];
  patient?: string | string[];
  groups: IUserGroup[];
  groupName: string;
}

export interface IUserAccess {
  manageGroupMembership: boolean;
  view: boolean;
  mapRoles: boolean;
  impersonate: boolean;
  manage: boolean;
}

export const UserConfig = {
  entityName: 'ADMINISTRATOR.USER.TITLE',
  PASSWORD: 'COMMON.PASSWORD',
  permissionEntityName: 'ADMINISTRATOR.PERMISSION.TITLE'
};

export const PatientConfig = {
  entityName: 'PATIENT_PORTAL.TITLE',
};
